import type { NavigateProps } from 'react-router';
import { useUser } from 'features/auth';
import { NavigateWithSearch } from '../navigate-with-search';
import { routes } from '../routes';

type P = {
  additionalSearch?: Record<string, string>;
} & Omit<NavigateProps, 'to'>;

const NavigateWithUserInfo = ({ additionalSearch, ...rest }: P) => {
  const { railsUserData: viewer } = useUser();

  return <NavigateWithSearch additionalSearch={additionalSearch} to={routes.members.detail(viewer.id)} {...rest} />;
};

export default NavigateWithUserInfo;
